const fields = `
  playerCount
  potAmount
`;

export const gameStatsFields = `
  ... on FalkorGame {
    stats {
      ${fields}
    }  
  }
  ... on QuitbetGame {
    ${fields}
  }
  ... on DietbetGame {
    ${fields}
  }
  ... on RunbetGame {
    ${fields}
  }
  ... on StepbetGame {
    ${fields}
  }
`;

const gameStat = (game, field) => (game?.stats || game || {})[field];

export const gamePlayerCount = (game) => gameStat(game, 'playerCount');

export const gamePotAmount = (game) => gameStat(game, 'potAmount');
